//#region IMPORT
import React from 'react';
import Lottie from 'lottie-react';
import AiAnimation from '../../../../Assets/animations/Loading.json';
import { Dialog } from '../../../../Components/MUIs';
import { Box, Stack, Typography } from '@mui/material';
import M_TBM_CUSTOM_01F from '../M_TBM_CUSTOM_01/M_TBM_CUSTOM_01F';
import M_TBM_CUSTOM_02F from '../M_TBM_CUSTOM_02/M_TBM_CUSTOM_02F';
import M_TBM_CUSTOM_03F from '../M_TBM_CUSTOM_03/M_TBM_CUSTOM_03F';
import M_TBM_CUSTOM_04F from '../M_TBM_CUSTOM_04/M_TBM_CUSTOM_04F';
import M_TBM_CUSTOM_05F from '../M_TBM_CUSTOM_05/M_TBM_CUSTOM_05F';
import M_TBM_CUSTOM_06F from '../M_TBM_CUSTOM_06/M_TBM_CUSTOM_06F';
//#endregion

function CustomLineStepper({ activeStep, steps }) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
        px: 2,
        py: 2,
      }}
    >
      {Array.from({ length: steps }).map((_, index) => (
        <Box
          key={index}
          sx={{
            flex: 1,
            height: 4,
            backgroundColor: index <= activeStep ? '#33ABD1' : '#e0e0e0',
            borderRadius: 2,
            ml: index === 0 ? 0 : 1, // 왼쪽에만 마진 주기
          }}
        />
      ))}
    </Box>
  );
}

function M_TBM_CUSTOM(props) {
  //#region 변수
  const components = [
    // 대기화면
    <M_TBM_CUSTOM_01F
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      tbmCdRef={props.tbmCdRef}
      ready={props.ready}
      setReady={props.setReady}
      setModalToggle1={props.setModalToggle1}
      modalToggle1={props.modalToggle1}
      setModalToggle2={props.setModalToggle2}
      modalToggle2={props.modalToggle2}
      ActiveButton={props.ActiveButton}
    />,
    // 동영상 교육
    <M_TBM_CUSTOM_02F
      check={props.check}
      setCheck={props.setCheck}
      setModalToggle1={props.setModalToggle1}
      modalToggle1={props.modalToggle1}
      setModalToggle2={props.setModalToggle2}
      modalToggle2={props.modalToggle2}
      userCount={props.userCount}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // pdf 교육
    <M_TBM_CUSTOM_03F
      check={props.check}
      setCheck={props.setCheck}
      setModalToggle2={props.setModalToggle2}
      modalToggle2={props.modalToggle2}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // 작업계획서
    <M_TBM_CUSTOM_04F
      check={props.check}
      setCheck={props.setCheck}
      setModalToggle2={props.setModalToggle2}
      modalToggle2={props.modalToggle2}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // 작업허가서
    <M_TBM_CUSTOM_05F
      check={props.check}
      setCheck={props.setCheck}
      setModalToggle2={props.setModalToggle2}
      modalToggle2={props.modalToggle2}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // tbm 완료
    <M_TBM_CUSTOM_06F
      tbmCdRef={props.tbmCdRef}
      userCount={props.userCount}
      TbmEnd={props.TbmEnd}
    />,
  ];
  //#endregion

  return (
    <Box sx={{ backgroundColor: '#F3F7F8', height: 'calc(100vh - 56px)' }}>
      <Stack sx={{ width: '100%', height: '100%' }}>
        <CustomLineStepper
          activeStep={props.activeStep}
          steps={components.length}
        />
        {components[props.activeStep] || null}
      </Stack>
      {props.modalToggle3 && (
        <Dialog
          open={props.modalToggle3}
          // onClose={(e) => props.setModalToggle1(false)}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  교육이 종료됩니다.
                </Typography>
                <Typography>관리자가 교육을 종료했어요.</Typography>
                <Typography>잠시 후 홈으로 이동합니다.</Typography>
              </Box>
            </Box>
          }
        />
      )}
      {props.modalToggle4 && (
        <Dialog
          open={props.modalToggle4}
          // onClose={(e) => props.setModalToggle4(false)}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  회의록 작성 중입니다.
                </Typography>
                <Typography>관리자가 회의록을 작성하고 있어요.</Typography>
                <Typography>잠시만 기다려 주세요.</Typography>
              </Box>
            </Box>
          }
        />
      )}
    </Box>
  );
}

export default M_TBM_CUSTOM;
